import {
  Block,
  LabelMedium,
  ListItem,
  ListItemLabel,
  useStyletron,
} from "@mezo-org/mezo-clay"

type MarketTransactionDetailsHeaderProps = {
  name: string
  description: string
  image: string
}

export default function MarketTransactionDetailsHeader({
  name,
  description,
  image,
}: MarketTransactionDetailsHeaderProps) {
  const [, theme] = useStyletron()

  return (
    <ListItem
      overrides={{
        Root: {
          style: {
            marginLeft: "0px",
            borderTop: `2px solid ${theme.colors.gray100}`,
            borderBottom: `1px solid ${theme.colors.gray100}`,
            borderLeft: "none",
            borderRight: "none",
            padding: theme.sizing.scale600,
          },
        },
        Content: { style: { marginLeft: "30px", borderBottom: "none" } },
      }}
      artwork={() => <Block as="img" width="64px" height="64px" src={image} />}
    >
      <ListItemLabel description={description}>
        <LabelMedium
          as="span"
          display="inline-block"
          marginBottom={theme.sizing.scale100}
        >
          {name}
        </LabelMedium>
      </ListItemLabel>
    </ListItem>
  )
}
